export default __webpack_public_path__ + "static/media/1GalQuickFillKit_8_main.b7cad4e5.png";